import React, { useState } from "react";
import { ReactDataTable } from "../../../components/Component";
import { carerNoteRemoveAPI, listCarerNoteAPI, listClientNoteAPI, noteData } from "./NoteData";
import { PER_PAGE_ITEMS, showSuccessToast } from "../../../utils";
import { useEffect } from "react";
import AddNotes from "./AddNote";
import { UserPermissionType, isCheckToList } from "../../../services/permission/permission";
export const NoteUserType = {
  hospital: "hospital",
  carer: "carer",
};
const NoteList = ({ parent, type, isOpenAddModel, onCloseModel, status }) => {
  const [noteList, setNoteList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [initScreen, setInitScreen] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const [modal, setModal] = useState(false);
  const [sortId, setSortId] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  useEffect(() => {
    setModal(isOpenAddModel);
  }, [isOpenAddModel]);
  useEffect(() => {
    reloadNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, type, status, sortId, sortOrder]);
  const onEdit = (row) => {
    setSelectedItem(row);
    setModal(true);
  };
  const moveToArchive = (row) => {
    // const apiCall = type === NoteUserType.hospital ? clientNoteRemoveAPI : carerNoteRemoveAPI;
    noteStatusChange(row?.id, "ARCHIVED");
  };
  const moveToActive = (row) => {
    noteStatusChange(row?.id, "ACTIVE");
  };
  const reloadNotes = () => {
    if (type === NoteUserType.hospital) {
      loadClientNote();
    } else if (type === NoteUserType.carer) {
      if (status) {
        loadCarerNote();
      }
    }
  };
  function noteStatusChange(noteId, newStatus) {
    let params = {
      noteId: noteId,
      status: newStatus,
    };
    carerNoteRemoveAPI(params, (_, error) => {
      if (error === null) {
        let statusLabel = newStatus === "ARCHIVED" ? "Archive" : "Active";
        showSuccessToast(`Note moved to ${statusLabel} successfully`);
        reloadNotes();
      }
    });
  }
  function loadClientNote() {
    if (type === NoteUserType.carer) return;
    if (isCheckToList(UserPermissionType.note)) {
      listClientNoteAPI(
        {
          pageInfo: {
            pageIndex: currentPage,
            itemsPerPage: PER_PAGE_ITEMS,
          },
          clientId: parent?.id,
        },
        (list, error) => {
          if (error === null) {
            setNoteList(list?.list || []);
            if (currentPage === 1) {
              setTotalItems(list?.pageInfo?.totalItems ?? 0);
            }
          }
          setInitScreen(false);
        },
      );
    }
  }
  function loadCarerNote() {
    if (type === NoteUserType.hospital) return;
    if (isCheckToList(UserPermissionType.note)) {
      listCarerNoteAPI(
        {
          pageInfo: {
            pageIndex: currentPage,
            itemsPerPage: PER_PAGE_ITEMS,
          },
          carerId: parent.id,
          status: status,
          sorting: {
            field: sortId ?? null,
            order: sortOrder ?? null,
          },
        },
        (list, error) => {
          if (error === null) {
            setNoteList(list?.list || []);
            if (currentPage === 1) {
              setTotalItems(list?.pageInfo?.totalItems ?? 0);
            }
          }
          setInitScreen(false);
        },
      );
    }
  }
  return (
    <React.Fragment>
      <ReactDataTable
        data={noteList}
        columns={noteData(onEdit, moveToArchive, moveToActive, type, status)}
        isAllowed={isCheckToList(UserPermissionType.note)}
        pagination
        totalItemCount={totalItems}
        onPageChanged={(page, count) => {
          setCurrentPage(page);
        }}
        onSort={(id) => {
          setSortId(id);
          const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
          setSortOrder(newSortOrder);
        }}
      />
      <AddNotes
        visible={modal}
        item={selectedItem}
        parents={[parent]}
        type={type}
        onClosed={() => {
          setModal(false);
          onCloseModel();
          setSelectedItem();
        }}
        onSaved={() => {
          type === NoteUserType.carer && loadCarerNote();
          type === NoteUserType.hospital && loadClientNote();
        }}
      />
    </React.Fragment>
  );
};
export default NoteList;
